var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCaretRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.899V5.58901C7.50004 5.42422 7.54893 5.26314 7.6405 5.12613C7.73207 4.98913 7.8622 4.88234 8.01445 4.81928C8.1667 4.75623 8.33423 4.73972 8.49586 4.77186C8.65748 4.804 8.80595 4.88334 8.9225 4.99985L13.5775 9.65485C13.7337 9.81112 13.8215 10.023 13.8215 10.244C13.8215 10.465 13.7337 10.6769 13.5775 10.8332L8.9225 15.4882C8.80595 15.6047 8.65748 15.684 8.49586 15.7162C8.33423 15.7483 8.1667 15.7318 8.01445 15.6687C7.8622 15.6057 7.73207 15.4989 7.6405 15.3619C7.54893 15.2249 7.50004 15.0638 7.5 14.899Z",
    fill: "#252525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRightIcon);
export default __webpack_public_path__ + "static/media/caretRight_icon.48aca44e0735893923d146881d6330d8.svg";
export { ForwardRef as ReactComponent };